export function truncateText(str: string | any[], maxLength: number) {
  return str.length > maxLength ? `${str.slice(0, maxLength)}...` : str;
}
